export function resolveMenuLabel(label: string, t: (key: string) => string) {
  if (!label.includes(':')) return label;
  return t(label);
}
